import { MaybeSearchPageNoProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/MaybeSearchPageNoProductResults/MaybeSearchPageNoProductResults";
import { SearchPageProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageProductResults/SearchPageProductResults";
import { SearchPageRetrievalQueries } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/SearchPageHeaderAndResults/__internal__/SearchPageResults/__internal__/SearchPageRetrievalQueries/SearchPageRetrievalQueries";
import { useSearchPageShouldShowProductResults } from "@faire/retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/useSearchPageShouldShowProductResults";
import { useTraceComponentRender } from "@faire/web/common/tracing/useTraceComponentRender";
import { Column } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import React from "react";
import styled from "styled-components";

interface IProps {
  title: string;
  searchPageLoadTimingRef?: React.Ref<HTMLDivElement>;
}

export const SearchPageResults: React.FC<IProps> = ({
  title,
  searchPageLoadTimingRef,
}) => {
  useTraceComponentRender("SearchPageResults");

  const shouldShowProductResults = useSearchPageShouldShowProductResults();
  return (
    <ResultsWrapper id="search-page-results-wrapper">
      <>
        <MaybeSearchPageNoProductResults
          searchPageLoadTimingRef={searchPageLoadTimingRef}
        />
        {shouldShowProductResults ? (
          <>
            <SearchPageRetrievalQueries />
            <SearchPageProductResults
              title={title}
              searchPageLoadTimingRef={searchPageLoadTimingRef}
            />
          </>
        ) : null}
      </>
    </ResultsWrapper>
  );
};

const ResultsWrapper = styled(Column)`
  flex: 1 1 auto;
  width: 100%;
  padding-top: ${getSpacing("1x")};
`;
